import React from 'react';
import styles from './styles/styles.module.css';
import { CiImageOff } from 'react-icons/ci';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

interface ProtectorCardInterface {
  firstName: string;
  lastName: string;
  status: string;
  hireDate: string;
  guardCardTitle: string;
  guardCardNumber: string;
  faCardTitle: string;
  faCardExp: string;
  faCardNumber: string;
  guardCardExp: string;
  ccwNumber: string;
  ccwExpiration: string;
  dlNumber: string;
  dlExpiration: string;
  userId: string;
}

const ProtectorCard: React.FC<ProtectorCardInterface> = ({
  userId,
  firstName,
  lastName,
  status,
  hireDate,
  guardCardTitle,
  faCardExp,
  faCardTitle,
  guardCardExp,
  faCardNumber,
  guardCardNumber,
  ccwNumber,
  ccwExpiration,
  dlNumber,
  dlExpiration,
}) => {
  // useSelector((state) => console.log(state));
  const { companyPermissions, sitePermissions, userType } = useSelector(
    (state: any) => state.user
  );

  //establishes if the click handler fires or not.
  function canClick() {
    if (userType === 'HYPER_ADMIN' || userType === 'COMPANY_ADMIN') {
      return true;
    } else {
      if (companyPermissions.editUsers || sitePermissions.editUsers) {
        return true;
      } else {
        return false;
      }
    }
  }

  const navigate = useNavigate();
  function returnBadge() {
    switch (status) {
      case 'ACTIVE':
        return {
          className: styles.badgeActive,
          text: 'Active',
        };
      case 'INACTIVE':
        return {
          className: styles.badgeInactive,
          text: 'Inactive',
        };

      case 'TERMINATED':
        return {
          className: styles.badgeTerminated,
          text: 'Terminated',
        };
      default: {
        return {
          className: styles.badgeActive,
          text: 'Active',
        };
      }
    }
  }

  function handleClick() {
    navigate(`/userInfo/${userId}`);
  }

  return (
    <div
      onClick={() => {
        if (canClick()) {
          handleClick();
        }
      }}
      className={styles.wrapper}
    >
      <div className={styles.topContainer}>
        <div className={styles.pictureFrame}>
          <CiImageOff className={styles.imagePlaceholder} />
        </div>
        <div className={styles.nameContainer}>
          <p className={styles.name}>{firstName}</p>
          <p className={styles.name}>{lastName}</p>
        </div>
        <div className={styles.badgeContainer}>
          <div className={returnBadge().className}>
            <p className={styles.badgeText}>{returnBadge().text}</p>
          </div>
        </div>
        <div className={styles.dividerLine}></div>

        <div className={styles.textContainer}>
          <p className={styles.mainText}>Hire Date</p>
          <p className={styles.mainText}>{hireDate}</p>
        </div>

        <div className={styles.textContainer}>
          <div className={styles.subContainerLeft}>
            <p className={styles.mainText}>{guardCardTitle}</p>
            <p className={styles.subText}>Expiration Date</p>
          </div>
          <div className={styles.subContainerRight}>
            <p className={styles.mainText}>{guardCardNumber}</p>
            <p className={styles.subText}>{guardCardExp}</p>
          </div>
        </div>

        <div className={styles.textContainer}>
          <div className={styles.subContainerLeft}>
            <p className={styles.mainText}>{faCardTitle}</p>
            <p className={styles.subText}>Expiration Date</p>
          </div>
          <div className={styles.subContainerRight}>
            <p className={styles.mainText}>{faCardNumber}</p>
            <p className={styles.subText}>{faCardExp}</p>
          </div>
        </div>

        <div className={styles.textContainer}>
          <div className={styles.subContainerLeft}>
            <p className={styles.mainText}>Concealed Carry</p>
            <p className={styles.subText}>Expiration Date</p>
          </div>
          <div className={styles.subContainerRight}>
            <p className={styles.mainText}>{ccwNumber}</p>
            <p className={styles.subText}>{ccwExpiration}</p>
          </div>
        </div>

        <div className={styles.textContainer}>
          <div className={styles.subContainerLeft}>
            <p className={styles.mainText}>Drivers License</p>
            <p className={styles.subText}>Expiration Date</p>
          </div>
          <div className={styles.subContainerRight}>
            <p className={styles.mainText}>{dlNumber}</p>
            <p className={styles.subText}>{dlExpiration}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProtectorCard;
